// https://vuex.vuejs.org/en/getters.html

export default {

    USER: state => {
        return state.user;
    },

    PRODUCT_CARD: state => {
        return state.product_card;
    },
    MESSAGES_CHAT: state => {
        return state.messages_chat;
    },
    BADGE: state => {
        return state.badge
    },
    BRANDS: state => {
        return state.brands;
    },
    BRAND: state => {
        return state.brand;
    },
    FEATURES: state => {
        return state.features;
    },
    CLASSES: state => {
        return state.classes;
    },
    CATEGORIES: state => {
        return state.categories;
    },
    RESOURCES: state => {
        return state.resources;
    },
    RESOURCE: state => {
        return state.resource;
    },
    VALUES: state => {
        return state.values;
    },
    PAGE_SET: state => {
        return state.pageSet;
    },
    SEARCH_SET: state => {
        return state.searchSet;
    },
    CATEGORY_SELECT_SET: state => {
        return state.categorySelect;
    },
    LANGUAGE_SET: state => {
        return state.language;
    }
}